module.exports = __webpack_public_path__ + "e.no1.9defa255.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/imgs/stories/kanai/female_to_male/e.no1.jpg
// module id = wjtB
// module chunks = 0